import { memo, useEffect, useState } from 'react';
import { useLiveStreamAppContext } from "../ContextStore/Store";
import { AmplitudeAddLog } from '../utils/AppAmplitude';
import { CallBackGivenForDismiss } from '../utils/AppUtils';
import { appInsightTrack } from '../utils/AppInsights';
import { getDeviceInfoDetails } from "../utils/PlatformCheck";

function ReviewSuccessAttendee({ reviewResponsePending }) {
  const {
    role,
    eventType,
    businessURL,
    __userId,
    __merchantId,
    grp,
    __appConfirmUniqueID,
    webUrlSubDomain,
    isPaid,
    checkOutUrl,
    isMobile,
    systemName,
    customerId,
    appointmentId
  } = useLiveStreamAppContext();
  const [completionCheck, setCompletionCheck] = useState(false);
  const deviceInfoDetails = getDeviceInfoDetails();

  const handleViewMoreLiveStreamClasses = () => {
    window.location.href = webUrlSubDomain + 'live-stream-classes';
  };

  const handleViewClassesFromThisBusiness = () => {
    window.location.href = webUrlSubDomain + businessURL + "/classes";
  };

  // Check if the value is purely numeric and convert it to a number
  const isNumber = /^[+-]?\d+(\.\d+)?$/.test(reviewResponsePending);
  const numericValue = isNumber ? Number(reviewResponsePending) : null;

  // Define the mapping object
  const responseMessages = {
    [-6]: "Review exists for the same appointment.",
    [-5]: "Reviewer must be active.",
    [-4]: "Employees can't review their own business.",
    [-1]: "Reviewer can't give more than 1 review to a business on the same day.",
    [-7]: "Something went wrong.",
    [-3]: "Service provider can't give own review.",
    [-2]: "Rating should be greater than 0."
  };


  // Get the message based on the response, or set a default message
  const headerText = numericValue !== null && responseMessages[numericValue]
    ? responseMessages[numericValue]
    : 'Your Review Has Been Posted.';

  const handleCloseWindow = () => {
    AmplitudeAddLog(__userId, __merchantId, businessURL, 115, grp, __appConfirmUniqueID);
    setTimeout(() => {
      CallBackGivenForDismiss();
      if (deviceInfoDetails.isMobileApp && !deviceInfoDetails.isAndroid) {
        try {
          window.close();
        } catch (e) {
          appInsightTrack(__merchantId, __userId, "Your Feedback has been submitted Dismiss", "", e);
        }
        window.location.href = role === "Presenter" ? 'closewindowpro://closewindowProURL' : 'closewindow://closewindowURL';
      } else {
        window.close();
      }
    }, 1500);
  };

  const handleCompletion = () => {
    if (isPaid) {
      setCompletionCheck(true);
      setTimeout(() => {
        if (navigator.userAgent.indexOf("com.vagaro.iospro") > -1) {
          var objData = '5006||~||{"message": "","messageType": 0,"screenTitle":"","screenType": 0,"navType": 0,"action": "147","jsonData": ' + JSON.stringify({ isPaid: true }) + ' }';
          setTimeout(() => { window.location = "js-call:myObjectiveCFunction:" + objData }, 100);
          return;
        } else if (systemName.includes("Android") || systemName.includes("AndroidTablet")) {
          window.location.href = process.env.REACT_APP_API_WS_URL + 'download.html?type=livestreamcheckout&navType=103&aid=' + appointmentId + '&ispaid=true' + '&cid=' + customerId;
          return;
        }
      }, 3000)
    } else {
      if (navigator.userAgent.indexOf("com.vagaro.iospro") > -1) {
        var objData = '5006||~||{"message": "","messageType": 0,"screenTitle":"","screenType": 0,"navType": 0,"action": "147","jsonData": ' + JSON.stringify({ isPaid: false }) + ' }';
        setTimeout(() => { window.location = "js-call:myObjectiveCFunction:" + objData }, 100);
        return;
      } else if (systemName.includes("Android") || systemName.includes("AndroidTablet")) {
        window.location.href = process.env.REACT_APP_API_WS_URL + 'download.html?type=livestreamcheckout&navType=103&aid=' + appointmentId + '&ispaid=false' + '&cid=' + customerId;
        return;
      } else {
        window.location.href = checkOutUrl;
      }
    }
  }

  // Automatically close the screen if the role is "Presenter"
  useEffect(() => {
    if (completionCheck) {
      const timer = setTimeout(() => {
        // Redirect to a specific page or close the screen
        window.close();
      }, 5000); // 5 seconds
      return () => clearTimeout(timer); // Cleanup the timer when the component unmounts
    }
  }, [completionCheck]);

  return (
    <div
      className="attendee-review-posted updateReviewPosted"
      style={{ display: "flex" }}
    >
      {role === "Presenter" ? (
        completionCheck ?
          <>
            <div className="attendee-review-posted-wrapper markedComplete">
              <div className="saving-vdo-icon">
                <i className="icon font-awesome-solid-pro va-check-circle"></i>
              </div>
              <h5 className="review-title">{eventType === 1 ? "Your Service Has Been Marked Completed" : "Your Class Has Been Marked Completed"}</h5>
            </div>
            {isMobile && <div className="ft-btn">
              <button
                className="cbtn brd-btn dismiss fullWidthBtn"
                onClick={handleCloseWindow}
              >
                <span>Done</span>
              </button>
            </div>}
          </>
          : <>
            <div className="attendee-review-posted-wrapper feedbackSubmitted">
              <div className="saving-vdo-icon">
                <i className="icon font-awesome-solid-pro va-check-circle"></i>
              </div>
              <h5 className="review-title">Your Feedback Has Been Submitted</h5>
            </div>
            <div className="ft-btn">
              <button
                className="cbtn brd-btn dismiss"
                onClick={handleCloseWindow}
              >
                <span>Done</span>
              </button>
              <button
                id="sendFeedback"
                className="cbtn thm-btn send-feedback"
                onClick={handleCompletion}
              >
                <span>{eventType === 1 ? "Mark Service as Complete" : "Mark Class as Complete"}</span>
              </button>
            </div>
          </>
      ) : (
        <div className="attendee-review-posted-wrapper">
          <div className="saving-vdo-icon">
            {typeof numericValue === 'number' ? (
              <div className="font-awesome-solid-pro icon-banner font-size25"></div>
            ) : (
              <i className="icon font-awesome-solid-pro va-check-circle"></i>
            )}
          </div>
          <h5 className="review-title">{headerText}</h5>
          <div className="text-16px gray _50px-below">
            {typeof numericValue === 'number' ? (
              ""
            ) : (
              "Your review has been posted online to the business page."
            )}
          </div>
          <div className="ft-btn btnBusinessReview">
            <button
              className="cbtn brd-btn dismiss"
              onClick={handleViewMoreLiveStreamClasses}
            >
              <span>View More Live Stream Classes</span>
            </button>
            <button
              className="cbtn thm-btn post-review"
              onClick={handleViewClassesFromThisBusiness}
            >
              <span>View Classes from This Business</span>
            </button>
          </div>
        </div>
      )}
    </div>

  );
}
export default memo(ReviewSuccessAttendee);